__webpack_require__.p = "/GestureDrawingProject/";